import type { ApiClient } from "../../api/client";
import type { PrintNotice } from "../../api/types";

/**
 * 🖨 A receipt printed again (Bestellingen, the Kassabon window): by the server on the receipt printer
 * of each order's kind, once. Empty when the shop has no printer for it: the till then prints from the
 * browser.
 */
export async function printAgain(api: ApiClient, orderIds: readonly string[]): Promise<PrintNotice[]> {
  const answer = await api.request<{ prints: PrintNotice[] }>("POST", "/orders/print", { body: { orderIds } });
  return answer.prints;
}
